import React from 'react';
import { Breakpoint } from '@noths/polaris-client-ribbons-base';
import type { CarouselLink } from '@noths/polaris-client-ribbons-design-system';
import { Media } from '@noths/polaris-client-ribbons-design-system';

import type { AccordionProps } from 'src/components/molecules/Accordion';
import { Accordion } from 'src/components/molecules/Accordion';
import type { LinkCarouselTrackingLinkSource } from '../../LinkCarousel';
import * as styles from '../styles';
import { AccordionContent } from './AccordionContent';

const hasCategoryDescription = (categoryDescription: string) =>
  categoryDescription && categoryDescription !== '<p></p>';

export interface HeaderCopyBlockProps {
  categoryDescription: string;
  categoryHeading: string;
  categorySubheading?: string;
  categoryLinks: CarouselLink[];
  landedOnPageOne: boolean;
  openOnMount: boolean;
  trackingLinkDataSource: LinkCarouselTrackingLinkSource;
}

/*
  HeaderCopyBlock renders Accordion both open and shut initially.
  The browser displays the appropriate view by leveraging media queries.
  Fresnel then changes this to conditional rendering, which prevents life-cycle
  methods from firing in hidden components and unused html being written to the DOM.
*/
export const HeaderCopyBlock = ({
  categoryDescription,
  categoryHeading,
  categorySubheading,
  categoryLinks,
  landedOnPageOne,
  openOnMount,
  trackingLinkDataSource,
}: HeaderCopyBlockProps) => {
  const accordionProps: AccordionProps = {
    buttonStyles: styles.copyBlockAccordionButton,
    titleStyles: styles.pageHeadingFontCSS,
    id: 'copy-block',
    title: categoryHeading,
  };
  const accordionContentProps = {
    categoryDescription: landedOnPageOne ? categoryDescription : undefined,
    categoryLinks,
    categorySubheading,
    trackingLinkDataSource,
  };

  return (
    <div css={styles.pageHeadingCSS}>
      {hasCategoryDescription(categoryDescription) || categoryLinks.length ? (
        <>
          <Media lessThan={Breakpoint.L}>
            <Accordion {...accordionProps} open={false}>
              <AccordionContent {...accordionContentProps} />
            </Accordion>
          </Media>
          <Media greaterThanOrEqual={Breakpoint.L}>
            <Accordion {...accordionProps} open={openOnMount}>
              <AccordionContent {...accordionContentProps} />
            </Accordion>
          </Media>
        </>
      ) : (
        <div css={styles.pageHeadingWrapperCSS}>
          <h1>{categoryHeading}</h1>
        </div>
      )}
    </div>
  );
};
